import type {Icon} from '@primer/octicons-react'

import {CustomIcon} from './CustomIcon'

// Regridded from the 16px Octicons CommentIcon outer contour with 9.5px optical bounds.
export const ReviewCommentedIcon: Icon = props => (
  <CustomIcon {...props} naturalWidth={12} naturalHeight={12}>
    <path d="M1.8438 3.1328c0-.5735.4655-1.039 1.039-1.039h6.2344c.5736 0 1.0391.4655 1.0391 1.039v4.4531c0 .5736-.4655 1.0391-1.0391 1.0391H6.6294l-1.5277 1.5277A.8657.8657 0 0 1 3.625 9.5412V8.625h-.7422c-.5735 0-1.039-.4655-1.039-1.0391Z" />
  </CustomIcon>
)
